import React from "react";
import { Container } from "react-bootstrap";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const PolitiqueConfidentialitePage = () => {
  return (
    <div className="politique-confidentialite-page">
      <PublicHeader />
      <Container className="py-5">
        <h1 className="mb-4">Politique de Confidentialité</h1>

        <div className="legal-content">
          <p>
            Cette politique de confidentialité s'applique au site : marion-livraison.com
          </p>
          <p>
            Elle a été mis à jour le : 01 Avril 2024
          </p>
          <p>
            Dans le cadre de son activité, la société La société Marion, dont le siège social est situé au 559 Chemin du Hameau de Plan Sarrain 06370 MOUANS SARTOUX, est amenée à collecter et à traiter des informations dont certaines sont qualifiées de « données personnelles ». La société Marion attache une grande importance au respect de la vie privée, et n'utilise que des données de manière responsable et confidentielle et dans une finalité précise.
          </p>

          <h2 className="mt-5 mb-3">Données Personnelles</h2>
          <p>
            Sur le site web marion-livraison.com, il y a 2 types de données susceptibles d'être recueillies :
          </p>

          <h3 className="mt-4 mb-2">Les données transmises directement</h3>
          <p>
            Ces données sont celles que vous nous transmettez directement, via un formulaire de contact ou bien par contact direct par email. Sont obligatoires dans le formulaire de contact les champs « Prénom, Nom », « Entreprise » et « Adresse Email ».
          </p>

          <h3 className="mt-4 mb-2">Les données collectées automatiquement</h3>
          <p>
            Lors de vos visites, une fois votre consentement donné, nous pouvons recueillir des informations de type « web analytics » relatives à votre navigation, la durée de votre consultation, votre adresse IP, votre type et version de navigateur. La technologie utilisée est le cookie. Pour évaluer si notre travail est efficace, nous faisons comme la plupart des sites web, nous mesurons notre audience en utilisant Google Analytics.
          </p>

          <h2 className="mt-5 mb-3">Utilisation des Données</h2>
          <p>
            Les données que vous nous transmettez directement sont utilisées dans le but de vous re-contacter et/ou dans le cadre de la demande que vous nous faites. Les données « web analytics » sont collectées de forme anonyme (en enregistrant des adresses IP anonymes) par Google Analytics, et nous permettent de mesurer l'audience de notre site web, les consultations et les éventuelles erreurs afin d'améliorer constamment l'expérience des utilisateurs. Ces données sont utilisées par la société Marion, responsable du traitement des données, et ne seront jamais cédées à un tiers ni utilisées à d'autres fins que celles détaillées ci-dessus.
          </p>

          <h2 className="mt-5 mb-3">Base Légale</h2>
          <p>
            Les données personnelles ne sont collectées qu'après consentement obligatoire de l'utilisateur. Ce consentement est valablement recueilli (boutons et cases à cocher), libre, clair et sans équivoque.
          </p>

          <h2 className="mt-5 mb-3">Durée de conservation</h2>
          <p>
            Les données seront sauvegardées durant une durée maximale de 3 ans.
          </p>

          <h2 className="mt-5 mb-3">Liste des cookies</h2>
          <p>Voici la liste des cookies utilisées et leur objectif.</p>

          <h3 className="mt-4 mb-2">Cookies nécessaires</h3>
          <p>
            Ce sont des cookies qui nous permettent d'être en mesure de vous proposer un bon fonctionnement du site web et qui vous permettent de faire usage des services que nous fournissons. Si ceux-ci sont bloqués, vous ne serez pas en mesure d'utiliser notre site web.
          </p>
          <ul>
            <li><strong>Nom des cookies :</strong> cookieconsent_status</li>
            <li><strong>Objectif :</strong> Permet de recueillir votre choix concernant l'utilisation de cookies sur notre site.</li>
            <li><strong>Durée de validité :</strong> Expire après 1 an par défaut.</li>
          </ul>

          <h3 className="mt-4 mb-2">Cookies statistiques</h3>
          <p>
            Google Analytics : outil Google d'analyse d'audience Internet permettant aux propriétaires de sites Web et d'applications de mieux comprendre le comportement de leurs utilisateurs. Cet outil utilise des cookies pour collecter des informations et générer des rapports sur le trafic (nombre de visites, temps passé sur le site, nombre de pages vues en moyenne, appareil et navigateur utilisé, emplacement géographique), l'origine du trafic (sources et campagnes à l'origine des visites) et la navigation (pages consultées, actions réalisées).
          </p>
          <ul>
            <li><strong>Nom des cookies :</strong> _ga | <strong>Objectif :</strong> Permet de distinguer les utilisateurs. | <strong>Durée de validité :</strong> Expire après 2 ans par défaut.</li>
            <li><strong>Nom des cookies :</strong> _gid | <strong>Objectif :</strong> Permet de distinguer les utilisateurs. | <strong>Durée de validité :</strong> Expire après 24 heures par défaut.</li>
            <li><strong>Nom des cookies :</strong> _gat | <strong>Objectif :</strong> Permet de réduire le taux de requête. | <strong>Durée de validité :</strong> Expire après 1 minute par défaut.</li>
          </ul>

          <h2 className="mt-5 mb-3">Opposition aux cookies</h2>
          <p>
            Le refus d'installation d'un cookie peut entraîner l'impossibilité d'accéder à certains services. L'utilisateur peut toutefois configurer son ordinateur de la manière suivante, pour refuser l'installation des cookies :
          </p>
          <ul>
            <li><strong>Sous Internet Explorer :</strong> onglet outil (pictogramme en forme de rouage en haut a droite) / options internet. Cliquez sur Confidentialité et choisissez Bloquer tous les cookies. Validez sur Ok.</li>
            <li><strong>Sous Firefox :</strong> en haut de la fenêtre du navigateur, cliquez sur le bouton Firefox, puis aller dans l'onglet Options. Cliquer sur l'onglet Vie Privée. Paramétrez les Règles de conservation sur : utiliser les paramètres personnalisés pour l'historique. Enfin décochez-la pour désactiver les cookies.</li>
            <li><strong>Sous Safari :</strong> Cliquez en haut à droite du navigateur sur le pictogramme de menu (symbolisé par un rouage). Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la section « Confidentialité », cliquez sur Paramètres de contenu. Dans la section « Cookies », vous pouvez bloquer les cookies.</li>
            <li><strong>Sous Chrome :</strong> Cliquez en haut à droite du navigateur sur le pictogramme de menu (symbolisé par trois lignes horizontales). Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la section « Confidentialité », cliquez sur préférences. Dans l'onglet « Confidentialité », vous pouvez bloquer les cookies.</li>
          </ul>

          <h2 className="mt-5 mb-3">Droits de l'utilisateur</h2>
          <p>
            L'utilisateur possède le droit de prendre connaissance, de mettre à jour, de modifier ou de supprimer les renseignements qui le concernent. Pour cela, l'utilisateur peut contacter la société Marion par email : contact@marion-livraison.com en précisant l'objet de sa demande.
          </p>

          <h2 className="mt-5 mb-3">Contact délégué à la protection des données</h2>
          <p>
            La société Marion – contact@marion-livraison.com
          </p>

          <h2 className="mt-5 mb-3">Conditions de modification de la Politique de Confidentialité</h2>
          <p>
            La présente politique de confidentialité peut être consultée à tout moment à l'adresse suivante : marion-livraison.com
          </p>
          <p>
            La société Marion se réserve le droit de la modifier afin de garantir sa conformité avec le droit en vigueur. Par conséquent, l'utilisateur est invité à venir consulter régulièrement cette politique de confidentialité afin de se tenir informé des derniers changements qui lui seront apportés.
          </p>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialitePage;
